import { render, staticRenderFns } from "./popDailySpeaking.vue?vue&type=template&id=cb7fb076&scoped=true&"
import script from "./popDailySpeaking.vue?vue&type=script&lang=js&"
export * from "./popDailySpeaking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7fb076",
  null
  
)

export default component.exports